<div class="tracking-container" [ngClass]="{'employee': !tracking.IST_MANNLOS, 'machine': tracking.IST_MANNLOS}">
  <div class="tracking-info">
    <ng-container *ngIf="tracking.STARTBUCH">
      <div>Start:</div>
      <div>{{ tracking.STARTBUCH | date : 'short' }}</div>
    </ng-container>

    <ng-container *ngIf="tracking.RESNAME">
      <div>Ressource:</div>
      <div>{{ tracking.RESNAME }}</div>
    </ng-container>

    <ng-container *ngIf="tracking.SERVICETYPENAME">
      <div>Wertungsart:</div>
      <div>{{ tracking.SERVICETYPENAME }}</div>
    </ng-container>

    <ng-container *ngIf="tracking.TASKNAME">
      <div>Leistungsart:</div>
      <div>{{ tracking.TASKNAME }}</div>
    </ng-container>

    <ng-container *ngIf="tracking.CREATORNAME">
      <div>Rückmelder:</div>
      <div>{{ tracking.CREATORNAME }}</div>
    </ng-container>
  </div>

  <div>
    <mat-form-field *ngIf="tracking.IST_MANNLOS">
      <input matInput placeholder="Maschinenzeit" (input)="onMachineWorkingTimeChanged($event)">
    </mat-form-field>
  </div>

  <div class="tag-container">
    <div *ngIf="!tracking.IST_MANNLOS" class="employee-tag">Mitarbeiter</div>
    <div *ngIf="tracking.IST_MANNLOS" class="machine-tag">Maschine</div>
  </div>
</div>
